import React, { Suspense } from "react";
import { DataProvider } from "./context/dataProvider";
import "./css/common.sass";
import Loading from "./common/Loading";
import MainRoute from "./MainRoute";
import { BrowserRouter } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

function App() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}>
      <DataProvider>
        <Suspense fallback={<Loading text="Loading" />}>
          <BrowserRouter>
            <MainRoute />
          </BrowserRouter>
        </Suspense>
      </DataProvider>
    </GoogleReCaptchaProvider>
  );
}

export default App;
